import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api } from '../../lib/api.ts';
import { KIND, type CalendarEvent } from '../../lib/schedule.ts';
import { Button } from '../../components/ui/Button.tsx';
import { todayLocal } from '../../lib/date.ts';

/** 월 캘린더: 발생 건·회차·과제 기한, 계약 만료, 증적 만료 */
export function CalendarPage() {
  const [month, setMonth] = useState(() => todayLocal().slice(0, 7));
  const q = useQuery({ queryKey: ['calendar', month], queryFn: () => api<{ month: string; events: CalendarEvent[] }>(`/schedule/calendar?month=${month}`) });
  const [y, m] = month.split('-').map(Number);
  const first = new Date(Date.UTC(y, m - 1, 1)); const daysIn = new Date(Date.UTC(y, m, 0)).getUTCDate(); const lead = first.getUTCDay();
  const cells: Array<string | null> = [...Array(lead).fill(null), ...Array.from({ length: daysIn }, (_, i) => `${month}-${String(i + 1).padStart(2, '0')}`)];
  while (cells.length % 7) cells.push(null);
  const byDate = new Map<string, CalendarEvent[]>(); for (const e of q.data?.events ?? []) byDate.set(e.date, [...(byDate.get(e.date) ?? []), e]);
  const shift = (d: number) => { const x = new Date(Date.UTC(y, m - 1 + d, 1)); setMonth(x.toISOString().slice(0, 7)); };
  const today = todayLocal();
  return (
    <div>
      <PageHeader title="캘린더" />
      <div className="flex items-center gap-2 mb-2"><Button variant="secondary" onClick={() => shift(-1)}>‹</Button><span className="font-semibold text-[14px] w-24 text-center">{y}년 {m}월</span><Button variant="secondary" onClick={() => shift(1)}>›</Button><Button variant="ghost" onClick={() => setMonth(new Date().toISOString().slice(0, 7))}>이번 달</Button>
        <span className="ml-3 flex gap-2 text-[11px]">{Object.entries(KIND).map(([k, v]) => <span key={k} className="inline-flex items-center gap-1"><span className="inline-block w-2.5 h-2.5" style={{ background: v.color }} />{v.label}</span>)}</span></div>
      <div className="grid grid-cols-7 border-t border-l border-slate-300 bg-white">
        {['일', '월', '화', '수', '목', '금', '토'].map((d) => <div key={d} className="border-r border-b border-slate-300 bg-slate-100 text-center text-[12px] py-1 font-semibold">{d}</div>)}
        {cells.map((d, i) => (
          <div key={i} className={`border-r border-b border-slate-200 min-h-24 p-1 ${d === today ? 'bg-accent-soft' : ''} ${!d ? 'bg-slate-50' : ''}`}>
            {d && <div className="text-[11px] text-slate-500 mb-0.5">{Number(d.slice(8))}</div>}
            {d && byDate.get(d)?.map((e, j) => <Link key={j} to={e.url} className={`block text-[11px] truncate px-1 mb-0.5 text-white ${['done', 'confirmed', 'skipped'].includes(e.status) ? 'opacity-40' : ''}`} style={{ background: KIND[e.kind]?.color ?? '#64748b' }} title={`${KIND[e.kind]?.label} · ${e.title} (${e.status})`}>{e.title}</Link>)}
          </div>
        ))}
      </div>
    </div>
  );
}
